import "core-js/modules/es.error.cause.js";
import defaultSettings from "./defaultSettings";
export default class FetchDataPlugin {
  // options：适合在初始化插件时，传入插件内部用到的参数
  constructor(options = {}) {
    if (!options.fetchCenter || !options.fetchUserById) {
      throw new Error('[FetchDataPlugin] 需要指定函数 fetchCenter, fetchUserById');
    }

    const apiTable = ['fetchTabs', 'fetchThead', 'fetchLeft', 'fetchCenter', 'fetchPosition', 'fetchAddGroup', 'fetchUserById'];
    apiTable.forEach(key => {
      if (options[key]) {
        this[key] = options[key];
        delete options[key];
      }
    });
    this.settings = Object.assign({}, defaultSettings, options);
  }

  install(ctx) {
    const self = this;
    const {
      settings
    } = self; // 添加自定义的props传给组件，不同的业务线可传入不同

    ctx.plugin('props', (vm, props) => {
      return { ...props,
        dialogTitle: settings.dialogTitle,
        dialogWidth: settings.dialogWidth,
        dialogCloseOnClickModal: settings.dialogCloseOnClickModal,
        required: settings.required,
        showDepartment: settings.showDepartment,
        showPosition: settings.showPosition,
        enableAddToGroup: settings.enableAddToGroup,
        type: settings.type,
        deptIds: settings.deptIds,
        //可选范围
        addButtonTabId: settings.addButtonTabId
      };
    });
    ctx.plugin('fetch-tabs', vm => {
      const {
        fetchTabs
      } = this;

      if (fetchTabs) {
        return fetchTabs.call(vm);
      }
    });
    ctx.plugin('fetch-thead', vm => {
      const {
        fetchThead
      } = this;

      if (fetchThead) {
        return fetchThead.call(vm);
      }
    }); // 查询左侧部分的组织架构信息

    ctx.plugin('fetch-left', async (vm, params, cb) => {
      const {
        fetchLeft
      } = this;

      if (fetchLeft) {
        fetchLeft.call(vm, params).then(result => cb(result));
      }
    }); // 查询中间部分的人员信息

    ctx.plugin('fetch-center', async (vm, params, cb) => {
      const {
        fetchCenter
      } = this;

      if (fetchCenter) {
        fetchCenter.call(vm, params).then(result => cb(result));
      }
    }); // 查询任职信息

    ctx.plugin('fetch-position', async (vm, params, cb) => {
      const {
        fetchPosition
      } = this;

      if (fetchPosition) {
        fetchPosition.call(vm, params).then(result => cb(result));
      }
    }); // 保存到个人群组

    ctx.plugin('fetch-add-group', async (vm, params, cb) => {
      const {
        fetchAddGroup
      } = this;

      if (fetchAddGroup) {
        fetchAddGroup.call(vm, params).then(result => cb(result));
      }
    }); // 根据工号查询人员信息

    ctx.plugin('fetch-user-by-id', async (vm, params, cb) => {
      const {
        fetchUserById
      } = this;

      if (fetchUserById) {
        fetchUserById.call(vm, params).then(result => cb(result));
      }
    });
  }

}